export default "__VITE_ASSET__SqyO$V6d__"